export const useScrollToTop = (threshold: number = 0.8) => {
  const showBackToTop = ref(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const handleScroll = () => {
    // Show button after scrolling past the threshold (default 80vh)
    showBackToTop.value = window.scrollY > window.innerHeight * threshold;
  };

  onMounted(() => {
    window.addEventListener('scroll', handleScroll);

    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll);
    });
  });

  return {
    showBackToTop: readonly(showBackToTop),
    scrollToTop,
  };
};
